import { getEnterpriseApi, updateEnterpriseApi } from './api';
import { useDispatch, useSelector } from '../../../react-redux';
import { setEnterprise, updateEnterprise } from '../../../reducers/enterprise';

const useEnterprise = () => {
  const dispatch = useDispatch();
  const enterprise = useSelector(state => state.getIn(['enterprise', 'enterprise']));
  const handleGetEnterprise = async () => {
    const res = await getEnterpriseApi();
    const token = res.data.token;
    if (token) {
      localStorage.setItem('_enterprise_token', token);
    }
    dispatch(setEnterprise(res.data));
    return res;
  };

  const handleUpdateEnterprise = data => {
    return updateEnterpriseApi(data).then(res => {
      dispatch(updateEnterprise(res.data));
    });
  };

  const handleUpdateEnterpriseStore = data => {
    dispatch(updateEnterprise(data));
  };

  return { enterprise, handleGetEnterprise, handleUpdateEnterprise, handleUpdateEnterpriseStore };
};

export default useEnterprise;
